import Skeleton from "./Skeleton";

// eslint-disable-next-line import/export
export * from "./Skeleton";
export default Skeleton;